import styled from 'styled-components'

import { ButtonIcon } from '../buttonIcon'

export const FloatingIconContainer = styled.div`
  z-index: 100;

  /*
   svh accounts for browser
   overlays (e.g. safari searchbar)
   when calculating size 

   Since the div is overlapping the screen,
   elements that depend on hovering might break.
   to fix this we can make the div a 1px screen-spanning vertical line.
  */
  height: 100vh;
  max-height: 100svh;
  width: 1px;

  float: right;
  position: absolute; // prevents the div from pushing elements
`

export const AlignmentContainer = styled.div`
  display: flex;
  // positioning to the bottom right corner
  flex-direction: row-reverse;
  position: absolute;
  bottom: 0;

  /* 
   Since the div is overlapping the screen,
   elements that depend on hovering might break.

   To fix this we can make the div a 
   1px screen-spanning horizontal line.
  */
  width: 100vw;
  height: 1px;

  & > * {
    /* 
     Child elements will be outside the visible area
     due to the div being a 1px thin line. 

     To account for this, we can use the translate property with
     the child's height (100%);
    */
    translate: 0 -100%;
  }
`

const marginSize = 25
export const FloatingIcon = styled(ButtonIcon)`
  transition: transform ease-in 0.2s;

  // negative Y margin is a workaround for keeping the element on-screen
  margin: -${marginSize}px ${marginSize}px;

  width: 8vw;
  height: 8vw;

  @media (max-width: 700px) {
    width: 12vw;
    height: 12vw;
  }

  &:hover {
    transform: scale(105%);
  }
`
